// Re-export from shared package
export {
  getRegexFromString,
  isEmpty,
  formatMoney,
  pad,
  makeCombineString,
  combineString,
  replaceAll,
  format,
  capitalizeFirstLetter,
} from 'oddle-shop-monorepo.utils'
